import { Smile } from "lucide-react";
import { SpecialtyPage } from "@/components/SpecialtyPage";

export default function DentalCare() {
  return (
    <SpecialtyPage
      icon={Smile}
      titleKey="specialties.dental.title"
      subtitleKey="specialties.dental.subtitle"
      overviewKey="specialties.dental.overview"
      procedures={[
        { nameKey: "specialties.dental.procedure1Name", descriptionKey: "specialties.dental.procedure1Desc", durationKey: "specialties.dental.procedure1Duration", recoveryKey: "specialties.dental.procedure1Recovery" },
        { nameKey: "specialties.dental.procedure2Name", descriptionKey: "specialties.dental.procedure2Desc", durationKey: "specialties.dental.procedure2Duration", recoveryKey: "specialties.dental.procedure2Recovery" },
        { nameKey: "specialties.dental.procedure3Name", descriptionKey: "specialties.dental.procedure3Desc", durationKey: "specialties.dental.procedure3Duration", recoveryKey: "specialties.dental.procedure3Recovery" },
      ]}
      advantagesKeys={["specialties.dental.advantage1", "specialties.dental.advantage2", "specialties.dental.advantage3"]}
      faq={[
        { questionKey: "specialties.dental.faq1Q", answerKey: "specialties.dental.faq1A" },
        { questionKey: "specialties.dental.faq2Q", answerKey: "specialties.dental.faq2A" },
        { questionKey: "specialties.dental.faq3Q", answerKey: "specialties.dental.faq3A" },
        { questionKey: "specialties.dental.faq4Q", answerKey: "specialties.dental.faq4A" },
        { questionKey: "specialties.dental.faq5Q", answerKey: "specialties.dental.faq5A" },
      ]}
      priceFromKey="specialties.dental.priceFrom"
      priceNoteKey="specialties.dental.priceNote"
      comparisonKey="specialties.dental.comparison"
      ctaTitleKey="specialties.dental.ctaTitle"
    />
  );
}
